<div class="form-container">
 <div></div>
 <app-form-designer style="overflow-y: hidden;"></app-form-designer> <!--overflow y hidden eliminates the scroll bar on entire page. Scroll bar was appearing for some reason when it should not have-->
 <div></div>
 </div>
